export default "__VITE_ASSET__BsA17x3J__"